import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/userPointLog/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/userPointLog/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/userPointLog/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/userPointLog/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/userPointLog/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/userPointLog/delete',
      method: 'delete',
      params: data
    })
  }
}
